import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Experiences from './components/Experiences';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Experiences />
      <Footer />
    </>
  );
}

export default App;
